module.exports = __webpack_public_path__ + "ab6c46ea4451fc8137ab66c7623fb4af.png";